import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { UsuariosService } from './usuarios.service';
import { UsuariosComponent } from './usuarios.component';
import { UsuariosDetalleComponent } from './detalle/usuarios-detalle.component';
import { UsuariosEditarComponent } from './editar/usuarios-editar.component';

const routes = [
    {
        path     : 'usuarios',
        component: UsuariosComponent
    },
    {
        path     : 'usuarios/detalle/:idUsuario',
        component: UsuariosDetalleComponent
    },
    {
        path     : 'usuarios/editar/:idUsuario',
        component: UsuariosEditarComponent
    },
    {
        path     : 'usuarios/nuevo',
        component: UsuariosEditarComponent
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        UsuariosComponent,
        UsuariosDetalleComponent,
        UsuariosEditarComponent
    ],
    providers: [UsuariosService]
})
export class UsuariosModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/usuarios/usuarios.module.ts